import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as typography from "@styles/typography.module.css";
import PhoneIcon from "@svgs/phoneIcon.svg";
import * as styles from "./phoneNumber.module.css";
const PhoneNumber = ({ text, phoneNumberComplete, }) => {
    return (_jsxs("a", { className: styles.phoneNumber, href: `tel:${phoneNumberComplete}`, "aria-label": `Ligue para ${text}`, children: [_jsx(PhoneIcon, {}), _jsx("p", { className: typography.button, children: text })] }));
};
export default PhoneNumber;
